(function() {
    'use strict';
    /*
     * Copyright (c) 2015 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .directive('ihhViewEditTextarea', ihhViewEditTextarea);

    /**
     * A directive for displaying a textarea field in read mode and changing it to a text input in edit mode. Intended for use with
     * controllers that derive from {@link ihh-common-web.ViewEditCtrlBase}.
     * @ngdoc directive
     * @name ihh-view-edit-textarea
     * @memberOf ihh-common-web
     * @example
     * <ihh-view-edit-textarea
     *    control-id="some-id"
     *    edit-flag="isEdit"
     *    is-required="true"
     *    label="Name"
     *    model="foo.name"
     *    model-edit="fooTemp.name">
     * </ihh-view-edit-textarea>
     */
    function ihhViewEditTextarea() {
        return {
            restrict: 'AE',
            transclude: true,
            scope: {
                /**
                 * The HTML id to use for the control and label, for accessibility.
                 * @ngdoc property
                 * @name control-id
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                controlId: '@',

                /**
                 * The text to display as a label.
                 * @ngdoc property
                 * @name label
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                label: '@',

                /**
                 * The condition to cause the editable element to focus.
                 * @ngdoc property
                 * @name focus
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                focus: '=',

                /**
                 * The number of rows the textarea should have.
                 * @ngdoc property
                 * @name rows
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                rows: '=',

                /**
                 * If set, marks the field as required, and in edit mode displayes a visual cue that the value is required.
                 * @ngdoc property
                 * @name is-required
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                isRequired: '=',

                /**
                 * The scope variable used to track view and edit mode.
                 * @ngdoc property
                 * @name edit-flag
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                editFlag: '=',

                /**
                 * The scope variable used as the model for displaying the text in view mode.
                 * @ngdoc property
                 * @name model
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                model: '=',

                /**
                 * The scope variable used as the model for the input field when in edit mode.
                 * @ngdoc property
                 * @name model-edit
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                modelEdit: '=',

                /**
                 * The scope variable used as the model for the input field default.
                 * @ngdoc property
                 * @name model-default
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                modelDefault: '=',

                /**
                 * The scope variable used to pass in a function to call when the text element is changed.
                 * @ngdoc property
                 * @name on-change
                 * @memberOf ihh-common-web.ihh-view-edit-textarea
                 */
                onChange: '&'
            },
            templateUrl: 'view-edit/view-edit-textarea.tpl.html',
            link: function( /*scope, elem, attrs*/ ) {
                // last chance init here
            }
        };
    }
})();